module.exports = __webpack_public_path__ + "static/media/cover_collect_int.7d0a4336.png";